import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import AccountsLanding from './AccountsLanding';
import AccountDetails from '../AccountDetails';

class Accounts extends Component {
  static propTypes = {
    accountDetailsData: PropTypes.instanceOf(Object),
    showAccountDetails: PropTypes.bool,
  }

  static defaultProps = {
    accountDetailsData: {},
    showAccountDetails: false,
  };

  state = {
  }

  render() {
    const { showAccountDetails, accountDetailsData } = this.props;
    if (_.isEmpty(accountDetailsData) && !showAccountDetails) {
      return (
        <div className="accounts-management">
          <AccountsLanding />
        </div>
      );
    }
    return (
      <div className="accounts-management">
        <AccountDetails />
      </div>
    );
  }
}

const mapStateToProps = ({ admin }) => {
  return {
    accountDetailsData: admin.accountDetailsData,
    showAccountDetails: admin.showAccountDetails,
  };
};


export default connect(mapStateToProps, {})(Accounts);
